import { render, staticRenderFns } from "./AffiliationCard.vue?vue&type=template&id=70e99462&scoped=true"
import script from "./AffiliationCard.vue?vue&type=script&lang=js"
export * from "./AffiliationCard.vue?vue&type=script&lang=js"
import style0 from "./AffiliationCard.vue?vue&type=style&index=0&id=70e99462&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e99462",
  null
  
)

export default component.exports